module.exports = __webpack_public_path__ + "img/gameinfo_0_.56385752.png";